'use client'

import { Center, Menu, Text } from '@mantine/core'
import { SUPPORTED_CURRENCIES } from '@partment/types'
import { RiCheckboxCircleFill } from '@remixicon/react'
import { useCurrency } from '@repo/ui'
import { useEffect, useState } from 'react'

const CurrencySelector = ({
  className = '',
  setMobileMenuOpen,
  fz = 14,
  placeholderText = '',
  width = 160,
}) => {
  const { currency, changeCurrency, isHydrated } = useCurrency()
  const [opened, setOpened] = useState(false)
  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    setIsMounted(true)
  }, [])

  const showActualCurrency = isMounted && isHydrated
  const selected = showActualCurrency
    ? SUPPORTED_CURRENCIES.find((c) => c.code === currency) ||
      SUPPORTED_CURRENCIES.find((c) => c.code === 'USD')
    : SUPPORTED_CURRENCIES.find((c) => c.code === 'USD')

  const handleCurrencyChange = (item) => {
    changeCurrency(item.code)
    setOpened(false)
    setMobileMenuOpen(false)
  }

  const menuItems = SUPPORTED_CURRENCIES.map((item) => (
    <Menu.Item key={item.code} onClick={() => handleCurrencyChange(item)}>
      <div className='flex justify-between items-center w-full'>
        <div className='flex gap-2'>
          <span className='text-[#101828] text-[12px]'>{item.symbol}</span>
          <span className='text-[#101828] text-[12px]'>{item.code}</span>
        </div>
        {selected?.code === item.code && <RiCheckboxCircleFill size={16} />}
      </div>
    </Menu.Item>
  ))

  // Check if className includes 'text-black' to determine if it should be plain text style
  const isPlainTextStyle = className.includes('text-black')

  return (
    <Menu
      opened={opened}
      onChange={setOpened}
      transitionProps={{ exitDuration: 0 }}
      withinPortal
      width={width}
    >
      <Menu.Target>
        <a
          href='#'
          className={`flex items-center justify-between ${isPlainTextStyle ? 'px-0 py-0 no-underline' : 'px-2 py-2'} cursor-pointer ${className}`}
          onClick={(e) => {
            e.preventDefault()
            setOpened((o) => !o)
          }}
        >
          {isPlainTextStyle ? (
            <span
              className='text-[#191919] font-normal'
              style={{ fontSize: `${fz}px` }}
            >
              {selected?.code}
            </span>
          ) : (
            <Center className='gap-2'>
              <Text fz={fz} className='text-[#FFFFFF] !font-medium'>
                {placeholderText !== ''
                  ? `${placeholderText} (${selected?.code})`
                  : selected?.code}
              </Text>
            </Center>
          )}
        </a>
      </Menu.Target>

      {/* Added rounded-[12px] for dropdown */}
      <Menu.Dropdown className='!rounded-xl'>{menuItems}</Menu.Dropdown>
    </Menu>
  )
}

export default CurrencySelector
